"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLookup = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2,4 L0,4 L0,20 L16,20 L16,18 L2,18 L2,4 Z M20,0 L4,0 L4,16 L20,16 L20,0 Z M18,14 L6,14 L6,2 L18,2 L18,14 Z M8,7 L16,7 L16,9 L8,9 L8,7 Z M8,10 L12,10 L12,12 L8,12 L8,10 Z M8,4 L16,4 L16,6 L8,6 L8,4 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconLookup')(IconLookup);